import { FC } from 'react'

import { Shipment } from 'src/types/shipments'

import ShipmentDetails from '../ShipmentDetails'

export interface ShipmentDetailsSectionProps {
  shipments: Shipment[]
}

const ShipmentDetailsSection: FC<ShipmentDetailsSectionProps> = ({
  shipments,
}) => (
  <>
    {shipments.map((shipment) => (
      <ShipmentDetails key={shipment.id} shipment={shipment} />
    ))}
  </>
)

export default ShipmentDetailsSection
